import { useState } from 'react'

import ArrowDownIcon from '@/assets/svg/ArrowDownIcon'
import ArrowUpIcon from '@/assets/svg/ArrowUpIcon'
import useKva, { LANDING_PAGE_LENDING } from '@/hooks/useKVA'

const LIST_FAQ = [
  {
    title: 'Hồ sơ đăng ký vay vốn qua KiotViet cần những gì?',
    detail: (
      <p className="text-text-strong text-base font-normal">
        <b>Bạn không cần chuẩn bị bất cứ giấy tờ gì</b>. KiotViet chỉ cần bạn
        xác nhận là chủ gian hàng và các thông tin bạn cung cấp là hoàn toàn
        chính xác.
        <br />
        <br /> Dựa trên sự đồng ý của bạn về việc chia sẻ dữ liệu gian hàng,
        chúng tôi sẽ tiến hành đánh giá tình hình kinh doanh dựa trên các tiêu
        chí mà ngân hàng đặt ra. Nếu bạn đáp ứng đủ các yêu cầu, KiotViet sẽ
        thay bạn chuẩn bị hồ sơ vay vốn và gửi đến ngân hàng.
        <br />
        <br /> <b>Lưu ý:</b> Dữ liệu về gian hàng của bạn chỉ được sử dụng cho
        mục đích vay vốn. KiotViet cam kết không sử dụng dữ liệu vào bất kỳ mục
        đích nào khác.
      </p>
    ),
    kva: 'Cần chuẩn bị hồ sơ gì',
  },
  {
    title: 'Không có đăng ký kinh doanh, tôi có thể vay vốn?',
    detail: (
      <p className="text-text-strong text-base font-normal">
        <b>Hoàn toàn được.</b>
        <br />
        <br />
        Chỉ cần gian hàng đáp ứng các tiêu chí vay vốn của ngân hàng, bạn vẫn có
        thể đăng ký các gói vay với chính sách tốt nhất mà không cần thế chấp
        tài sản hay có giấy phép kinh doanh..
      </p>
    ),
    kva: 'Không có đăng ký kinh doanh',
  },
  {
    title:
      'Vợ tôi đứng tên trên hợp đồng dịch vụ KiotViet, vậy tôi có thể đứng tên vay trên KiotViet được không?',
    detail: (
      <p className="text-text-strong text-base font-normal">
        Nếu bạn là chủ hộ kinh doanh, bạn có thể đăng ký vay vốn qua KiotViet.
        Tuy nhiên, bạn cần liên hệ tổng đài 1900 6522 để yêu cầu thay đổi thông
        tin trên hợp đồng KiotViet.
      </p>
    ),
    kva: 'Vợ đứng tên',
  },
  {
    title: 'Tôi có thể đăng ký vay cùng lúc nhiều ngân hàng không?',
    detail: (
      <p className="text-text-strong text-base font-normal">
        <b>Hoàn toàn có thể.</b>
        <br />
        <br />
        KiotViet hỗ trợ tiếp nhận và gửi hồ sơ của bạn đến một (hoặc nhiều) ngân
        hàng, với điều kiện bạn chứng minh được nguồn thu nhập và có khả năng
        trả nợ với các đơn vị cho vay.
      </p>
    ),
    kva: 'Cùng lúc Vay nhiều ngân hàng',
  },
  {
    title: 'KiotViet có thu thêm khoản phí nào từ tôi không?',
    detail: (
      <p className="text-text-strong text-base font-normal">
        <b>Hoàn toàn không.</b>
        <br />
        <br /> KiotViet không thu thêm bất kỳ khoản phí nào từ bạn. Tất cả quy
        trình đều được KiotViet hỗ trợ miễn phí nhằm giúp bạn tiếp cận với nguồn
        vốn phù hợp và tối ưu nhất.
      </p>
    ),
    kva: 'Chi phí vay vốn',
  },
  {
    title: 'Nếu có vấn đề cần xử lý, tôi sẽ liên hệ qua đâu?',
    detail: (
      <p className="text-text-strong text-base font-normal">
        Toàn bộ thông tin liên quan đến vay vốn đã được KiotViet mô tả chi tiết
        tại trang FAQs. Ngoài ra, bạn có thể liên hệ trực tiếp đến tổng đài 1900
        6522 để được hỗ trợ.
      </p>
    ),
    kva: 'Kênh hỗ trợ',
  },
]

export default function Support() {
  return (
    <div
      id="cau-hoi-thuong-gap"
      className="flex flex-col my-[64px] mx-8 lg:my-[94px] lg:mx-auto gap-14"
    >
      <div
        id="cau-hoi-thuong-gap-title"
        className="text-navy text-center text-[30px] leading-9 font-bold "
      >
        Câu hỏi thường gặp
      </div>
      <div className="flex flex-col items-center lg:w-[955px] md:w-[704px] w-[343px] mx-auto">
        <ul className="flex flex-col text-text-strong p-0 m-0 border-solid border-[#C2C7CE] border-[1px] rounded-[14px]">
          {LIST_FAQ.map((faq, index) => {
            return <Accordion faq={faq} index={index} key={index} isLastItem={index === LIST_FAQ.length - 1} />
          })}
        </ul>
      </div>
    </div>
  )
}

const Accordion = ({ faq, isLastItem }) => {
  const { addEventAction } = useKva()

  const [isOpen, setIsOpen] = useState(false)
  const toggle = () => {
    if (!isOpen) {
      addEventAction(LANDING_PAGE_LENDING, 'open_FAQ', faq.kva)
    }
    setIsOpen(!isOpen)
  }
  const accordionBorderCss = isOpen
    ? 'rounded-[12px] border-[1.5px] border-solid border-brand-primary-500'
    : isLastItem 
      ? ''
      : 'border-b-[1px] border-solid border-b-[#E8EAED]'
  const Arrow = () => (isOpen ? <ArrowUpIcon /> : <ArrowDownIcon />)
  const faqListCss = isOpen ? 'max-h-max rounded-[12px] pt-4 pb-5 ' : 'max-h-0'
  return (
    <li
      className={`relative w-full text-xs sm:text-sm flex items-center flex-wrap select-none ${accordionBorderCss}`}
    >
      <div
        className="flex gap-3 justify-between w-full px-6 py-4 cursor-pointer"
        onClick={toggle}
      >
        <div className="text-base font-semibold max-md:max-w-[259px]">
          {faq.title}
        </div>
        <div className="flex item-center justify-center w-6 h-6">
          <div className="m-auto">
            <Arrow />
          </div>
        </div>
      </div>

      <div
        className={`max-h-0 basis-full border-blue-300 overflow-hidden transition-all select-text px-6 bg-neutral-25 ${faqListCss}`}
      >
        {faq.detail}
      </div>
    </li>
  )
}
